import PropTypes from 'prop-types'
import {poiNameMap} from '../helpers'
import {usePointOfInterest} from '../../../../../store/hooks/pointOfInterest'
import {
  StyledBoxTooltip,
  StyledPaperTooltipWithPadding,
  StyledPOIHeaderText,
  StyledPOILabel,
  StyledAddressLabel,
  StyledAddressData
} from './Styles'
import {Legend} from '../Legends/POILegendStyle'
import {getPOIImageUrl} from '../../../helper'
import {useConfig} from '../../../../../store/hooks/config'
import {Divider, Stack} from '@mui/material'

const POITooltip = ({data}) => {
  const {address, city, name, state, type, zip, address2 = ''} = data
  const {existingPOI} = usePointOfInterest()
  const label = existingPOI?.find((existingPoi) => existingPoi?.value === type)?.customLabel || poiNameMap?.[type]?.[0]
  const {POIConfig: poiConfig} = useConfig() || {}

  return (
    <StyledBoxTooltip tooltipWidth={300}>
      {/* POI TOOLTIP HERE */}
      <StyledPaperTooltipWithPadding>
        <Stack spacing={1} direction='column'>
          <Stack direction='row' spacing={1} alignItems='center'>
            <Legend alt={`${label} icon`} src={getPOIImageUrl(poiConfig?.[type]?.markerProps?.iconURL)} />
            <StyledPOIHeaderText>Points Of Interests</StyledPOIHeaderText>
          </Stack>
          <StyledPOILabel color={poiNameMap?.[type]?.[1]}>{label}</StyledPOILabel>
          <Divider />
          <Stack direction='column' spacing={1}>
            <StyledAddressLabel>Address</StyledAddressLabel>
            <StyledAddressData>
              {name}, {address},{address2 ? ` ${address2},` : ''} {city}, {state}, {zip}.
            </StyledAddressData>
          </Stack>
        </Stack>
      </StyledPaperTooltipWithPadding>
    </StyledBoxTooltip>
  )
}

POITooltip.propTypes = {
  data: PropTypes.object
}

export default POITooltip

/**
 * List of functions and their purpose:
 *
 * - POITooltip: Renders a tooltip displaying detailed information about a point of interest (POI), including its name, address, and type.
 */
